import React from "react"
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"
import MultiSelect from "../../Selects/MultiSelect"

// import SeasonalRate from "./SeasonalRate"
import SeasonBuilderErrors from "../SeasonBuilderErrors"

class SeasonBuilderRates extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.activeTab == 'rates',
      'tab-pane': true
    })
    var inputs = this.props.all_rates.map(rate => {
      return {
        label_primary: rate.code,
        label_secondary: rate.name,
        id: rate.id,
        status: (rate.status == "enabled" ? null : "disabled"),
      }
    })
    return (
      <div className={tabClasses} id="rates">
        <div className="row">
          <div className="col-md-12">
          { inputs.length
          ?
            <MultiSelect
              header_primary="code"
              header_secondary="name"
              inputs={inputs}
              selected_inputs={this.props.seasonal_rates}
              onChange={this.props.onChangeSeasonalRates}/>
          :
            <div className="no-records">
              <span className="none">{I18n.t('none')}</span>
            </div>
          }
          </div>
        </div>
      </div>
    )
  }


  // constructor(props) {
  //   super(props)
  //   this.isChecked = this.isChecked.bind(this)
  //   this.selectAllNone = this.selectAllNone.bind(this)
  //   this.selectOne = this.selectOne.bind(this)
  // }
  //
  // render() {
  //   // console.log("rate",this.props)
  //   var self = this;
  //   var tabClasses = clsx({
  //     'active': this.props.activeTab == 'rates',
  //     'tab-pane': true
  //   })
  //   var all_rates = this.props.all_rates.map((rate) => {
  //     var seasonal_rate = this.getSeasonalRate(rate)
  //     return (
  //       <SeasonalRate
  //         key={rate.id}
  //         rate={rate}
  //         season_id={this.props.id}
  //         seasonal_rate={seasonal_rate}
  //         selectOne={this.selectOne}
  //         isChecked={this.isChecked} />
  //     )
  //   })
  //   const enabled_rates = this.props.seasonal_rates.filter(seasonal_rate => seasonal_rate.status === 'enabled')
  //   if (enabled_rates.length !== this.props.seasonal_rates.length && this.props.seasonal_rates.length !== 0 && enabled_rates.length !== 0) {
  //     $(this.refs.selectAll).prop("indeterminate", true)
  //   }
  //   var header = <strong>{I18n.t('code') + ': ' + I18n.t('name') + ' (' + I18n.t('billing_policy') + ')'}</strong>
  //   var disabled_alert = <div>{I18n.t('rate_selection_helper_text')}</div>
  //   return (
  //     <div className={tabClasses}>
  //       { SeasonBuilderErrors.renderRatesErrors(this.props.errors) }
  //       <div className="row">
  //         <div className="col-md-12">
  //         <div className="select-all-none" id="selected_rooms">
  //           <div>
  //             {}
  //           </div>
  //                 { all_rates.length
  //                 ?
  //                 <div className="toggle">
  //                   <label>
  //                     <input
  //                       ref="selectAll"
  //                       type="checkbox"
  //                       style={{ marginRight: 8 }}
  //                       checked={enabled_rates.length === this.props.seasonal_rates.length ? true : false}
  //                       onChange={this.selectAllNone}
  //                     />
  //                     <span>{header} <span className="ss-help help" title={I18n.t('rate_selection_helper_text')}></span></span>
  //                   </label>
  //                   <hr />
  //                 </div>
  //                 :
  //                 ""
  //                 }
  //               <div className="items">
  //                 {
  //                   all_rates && all_rates.length
  //                     ? all_rates
  //                     : <div className="no-records" style={{marginBottom: 10}}>
  //                         <span className="none">{I18n.t('none')}</span>
  //                       </div>
  //                 }
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   )
  // }
  //
  // getSeasonalRate(rate) {
  //   for (var i = 0, ilen = this.props.seasonal_rates.length; i < ilen; i++) {
  //     if (this.props.seasonal_rates[i].rate_id == rate.id) {
  //       return this.props.seasonal_rates[i];
  //     };
  //   };
  // };
  //
  // selectAllNone(event) {
  //   var seasonal_rates
  //   if (event.target.checked) {
  //     seasonal_rates = this.props.all_rates.map(rate => {
  //       return {
  //         rate_id: rate.id,
  //         season_id: this.props.id,
  //         status: 'enabled'
  //       }
  //     })
  //   } else {
  //     seasonal_rates = this.props.all_rates.map(rate => {
  //       return {
  //         rate_id: rate.id,
  //         season_id: this.props.id,
  //         status: 'disabled'
  //       }
  //     })
  //   }
  //   this.props.onChangeSeasonalRates(seasonal_rates)
  //   $(this.refs.selectAll).prop("indeterminate", false)
  // }
  //
  // selectOne(seasonal_rate){
  //   var seasonal_rates = [...this.props.seasonal_rates]
  //   for(var i = 0; i < seasonal_rates.length; i++){
  //     if(seasonal_rates[i].rate_id === seasonal_rate.rate_id){
  //       seasonal_rates[i] = seasonal_rate
  //       break
  //     }
  //   }
  //   this.props.onChangeSeasonalRates(seasonal_rates)
  //   $(this.refs.selectAll).prop("indeterminate", false)
  // }
  //
  // isChecked(id) {
  //   for(var i = 0; i < this.props.seasonal_rates.length; i++){
  //     if(this.props.seasonal_rates[i].rate_id === id && this.props.seasonal_rates[i].status === 'enabled') return true
  //   }
  //   return false
  // }

}

export default SeasonBuilderRates
